import HistoricBasicInformationSection from "../../../../features/bonds/shared/components/HistoricBasicInformationSection";
import { HISTORIC_BASIC_INFO_CONFIG } from "../../../../features/bonds/shared/historicBasicInformationConfig";

const VAHistoricBasicInformationForm = (props) => (
  <HistoricBasicInformationSection config={HISTORIC_BASIC_INFO_CONFIG.va} {...props} />
);

export default VAHistoricBasicInformationForm;
